require("../css/dialog.css")

export default new class AnyFormTools {

	/**
	 * Seznam otevřených dialogů.
	 * Využívá se pro postupné zavírání pomocí escape
	 * @type {Array}
	 */
	openDialogs = [];

	isInitOnce = false;

	/**
	 * @public
	 */
	init() {
		var _this = this;
		$(".anyDialog-backgroundOverlay").each(function () {
			_this.initDialog($(this));
		});
	}

	/**
	 * Inicializace jednoho zobrazeného dialogu
	 * @private
	 */
	initDialog(backgroudOverlay) {
		if (backgroudOverlay.hasClass("show")) {
			return;
		}
		this.openDialogs.push(backgroudOverlay);

		this.showBackgroundOverlay(backgroudOverlay);

		this.dialogPosition(backgroudOverlay);

		this.initClose(backgroudOverlay);
	}

	/**
	 * Zorazí a napozicuje dialog
	 * @param backgroudOverlay
	 */
	dialogPosition(backgroudOverlay) {
		var dialog = $(backgroudOverlay.find(".anyDialog-main")[0]);
		// zobrazení hlavního containeru dialogu
		dialog.addClass("show");

		var customTop = backgroudOverlay.attr("data-top");
		var containerTop = this.getInitTopPosition(dialog);
		// odsazení shora centrovacího divu dialogu dle nascrolování obrazovky
		$(backgroudOverlay.find(".anyDialog-centerContainer")[0]).css({
			top: customTop ? customTop : containerTop + "px"
		});
	}

	/**
	 * Vypočítá pozici dialogu tak aby byl vycentrovaný
	 * Vrací pozici TOP
	 * @param dialog
	 * @returns {number}
	 */
	getInitTopPosition(dialog) {
		var minTop = window.scrollY + 20;
		var screenHeight = $(window).height();
		var dialogHeight = dialog.height();
		if (dialogHeight > screenHeight) { // dialog je větší než obrazovka?
			return window.scrollY + 20;
		} else {
			var top = Math.round((screenHeight - dialogHeight) / 2);
			var newTop = window.scrollY + top - 100;
			return newTop < minTop ? minTop : newTop;
		}
	}

	/**
	 * Inicializace zavření dialogu
	 * @param backgroudOverlay
	 */
	initClose(backgroudOverlay) {
		var _this = this;
		$(backgroudOverlay.find(".anyDialog-btnClose")[0]).click(function () {
			_this.close(backgroudOverlay);
			return false;
		});

		// inicialiuace zavření pomocí escape musí proběhnout pouze jedenkát pro všechny dialogu
		if (this.isInitOnce == false) {
			document.addEventListener('keydown', function (ev) {
				var keyCode = ev.keyCode || ev.which;
				if (keyCode === 27) {
					var i = _this.openDialogs.length - 1;
					if (i != -1) { // zabespečení aby nešel escape použít pokud není otevřený žádný dialog
						_this.close(_this.openDialogs[i]);
					}
				}
			});
		}
		this.isInitOnce = true;
	}

	/**
	 * Zavře dialog
	 * @param backgroudOverlay
	 */
	close(backgroudOverlay) {
		$(backgroudOverlay.find(".anyDialog-main")[0]).slideUp(200, function () {
			$.nette.ajax(backgroudOverlay.attr("data-link-close"));
			backgroudOverlay.remove();
			$(backgroudOverlay.find(".anyDialog-main")[0]).remove();
		});

		this.openDialogs.splice(this.openDialogs.length - 1, 1);
	};

	/**
	 * Zobrazí a napozicuje šedé pozadí pod dialogem
	 * @param backgroudOverlay
	 */
	showBackgroundOverlay(backgroudOverlay) {
		// napozicování stínu pod dialogem tak aby byl vypisován z hora a leva.
		// Pokud je dialog v komponentě tak se pozicuje s hora a kreje konkrétní komponenty
		var dialogOverlayPosition = backgroudOverlay.offset();
		// šedé pozadí
		backgroudOverlay.css({
			top : -dialogOverlayPosition.top,
			left: -dialogOverlayPosition.left
		});
		backgroudOverlay.width($(window).width());
		backgroudOverlay.height($(document).height());

		backgroudOverlay.addClass("show");
	}
}


// WEBPACK FOOTER //
// ./node_modules/@anything-studio/dialog/src/js/index.js